// extracted by mini-css-extract-plugin
module.exports = {"root":"ResponseInfo_root__1LsXH","text":"ResponseInfo_text__3beoH"};